import { DealerID } from "./Dealer";
import { UserID } from "./User";

export type PublicAccountID = number;

export type PublicAccountLogID = number;

export enum PUBLIC_ACCOUNT_STATUSES {
  PublicAccountActive = 1,
  PublicAccountRevoked = 2
}

export enum PUBLIC_ACCOUNT_ACTIONS {
  ShowKey = 1,
  RevokeKey = 2
}

export interface PublicAccount {
  created_on: string;
  updated_on: string;
  id: PublicAccountID;
  name: string; // Name of the PublicAccount
  status: PUBLIC_ACCOUNT_STATUSES; // PublicAccount Status
  last_used_at: string | null; // Time when api key is last used
  disabled_at: string | null; // Time when api key is revoked
  dealer_id: DealerID; // Dealer's ID for the PublicAccount
  created_by_id: UserID; // ID of the user who created the PublicAccount
  purpose: string; // Purpose for which the PublicAccount going to be used
  contact: string; // Contact detail of the PublicAccount
  request_count: number; // Count of requests made
  request_count_expires_at: string | null; // Expiry time for the count of requests
  created_by_name?: string; // Name of the user who created the public account
  dealer_name?: string; // Name of the dealer associated
}

export interface PublicAccountLog {
  created_on: string;
  updated_on: string;
  id: PublicAccountLogID;
  public_account_id: PublicAccountID;
  user_id: UserID;
  action: PUBLIC_ACCOUNT_ACTIONS;
  reason: string;
  created_by_name?: string;
}
